import { render, staticRenderFns } from "./company-more.vue?vue&type=template&id=fe906aea&scoped=true&"
import script from "./company-more.vue?vue&type=script&lang=js&"
export * from "./company-more.vue?vue&type=script&lang=js&"
import style0 from "./company-more.vue?vue&type=style&index=0&id=fe906aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe906aea",
  null
  
)

export default component.exports